import { Component } from '@angular/core';
import { SubSink } from 'subsink';

import { DashboardStore } from '../dashboardv2.store';

@Component({
  selector: 'app-revenue',
  templateUrl: './revenue.component.html',
  styleUrls: [
    '../dashboardv2.component.scss',
    './revenue.component.scss',
  ],
})
export class RevenueComponent {

  revenue$ = this.dashboardStore.revenueViewModel$;

  subs = new SubSink();

  constructor(
    private readonly dashboardStore: DashboardStore,
  ) {}

}
